import { Card } from '@/components/ui/card';
import { GiftCardCheckCodeFragment } from '@/gql/generated';
import { formatDateToTimezone } from '@/lib/timezone';
import { formatGiftCard, formatNumberToCurrency } from '@/lib/utils';

const GiftCardDetail = ({
  giftCardDetail,
  code,
  timeZone,
}: {
  giftCardDetail: GiftCardCheckCodeFragment;
  code: string;
  timeZone: string;
}) => {
  return (
    <div>
      <Card className="mx-auto mb-4 p-4 transition-all hover:border-blue-200 md:mb-6">
        <div className="flex flex-col gap-2 font-bold">
          <div className="flex flex-row">
            <div className="flex-none text-left">Code: </div>
            <div className="w-full text-right">
              {formatGiftCard(code ?? '')}
            </div>
          </div>
          <div className="flex flex-row">
            <div className="flex-none text-left">Created At: </div>
            <div className="w-full text-right">
              {formatDateToTimezone(
                giftCardDetail.created_at ?? '',
                timeZone,
                'LLL d, yyyy hh:mm a',
              )}
            </div>
          </div>
          <div className="flex flex-row">
            <div className="text-left">Amount: </div>
            <div className="w-full text-right">
              {formatNumberToCurrency(giftCardDetail.amount)}
            </div>
          </div>

          <div className="flex flex-row">
            <div className="text-left">Balance: </div>
            <div className="w-full text-right">
              {formatNumberToCurrency(giftCardDetail.current_balance)}
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default GiftCardDetail;
